import React, { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Checkbox, FormControlLabel, useMediaQuery } from '@mui/material';
import { ButtonClassNames, LocalStorageItems, GlobalRouteNames } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';

interface ICheckRouterCapability {
  title: string | undefined;
  search: string | undefined;
  handleClose: () => void;
  isDaily: boolean;
}

export const CheckRouterCapability: FC<ICheckRouterCapability> = ({ title, search, isDaily, handleClose }) => {
  const { t } = useTranslation();
  const [showAgain, setShowAgain] = useState(false);
  const history = useHistory();
  const isMobile = useMediaQuery('(max-width:767px)');

  const handleChangeAfterCheckingRouter = () => {
    if (showAgain) {
      localStorage.setItem(LocalStorageItems.RouterCapabilityChecked, '1');
    }

    handleClose();

    setTimeout(() => {
      history.push({
        pathname: isDaily ? GlobalRouteNames.DailyServicePayment : GlobalRouteNames.ServicePayment,
        search,
      });
    }, 300);
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{title}</article>
        <p className="modals__header__description">{t('modals.checkRouterCapability')}</p>
        <FormControlLabel
          className="input input__checkbox"
          style={isMobile ? { justifySelf: 'center' } : { width: 'fit-content' }}
          control={
            <Checkbox
              checked={showAgain}
              onChange={({ target }) => setShowAgain(target.checked)}
              size="medium"
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label={t('modals.notShowAgain')}
        />
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.proceed')}
          handleClick={handleChangeAfterCheckingRouter}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
